import { useEffect } from "react";
import { atom, useSetRecoilState } from "recoil";

export const confirmationModalState = atom({
    default: {
        modal: false,
        text: '',
        confirmationFunction: () => {}
    },
    key: 'confirmationModal'
});

export default function useConfirmation () {
    const setState = useSetRecoilState(confirmationModalState);
    
    const trigger = (text: string, confirmationFunction: () => any) => setState(prev => {
        return {
            text,
            confirmationFunction,
            modal: true
        }
    });

    return {
        trigger
    }
}   